var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDots = function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6A6A",
    d: "M18 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
  })));
};
export default SvgDots;